require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./grant-county-restitution-advocate.json") })
        }
      }, "path---grant-county-restitution-advocate");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---grant-county-restitution-advocate!./.cache/json/grant-county-restitution-advocate.json
// module id = 898
// module chunks = 231608221292675